import {
	type CreateShareLink,
	createdShareLinkSchema,
	createShareLinkSchema,
	shareLinkSchema,
} from "../schemas/share-link";
import { fetchApi, fetchVoid, paginatedSchema, toSearchParams } from "./internal";

export const shareLinks = {
	// async so an invalid body rejects the returned promise instead of throwing
	// synchronously out of `createShareLinkSchema.parse`.
	create: async (data: CreateShareLink) =>
		fetchApi("/admin/links", createdShareLinkSchema, {
			body: JSON.stringify(createShareLinkSchema.parse(data)),
			method: "POST",
		}),
	list: (params?: { limit?: number; offset?: number }) => {
		const qs = toSearchParams(params ?? {});
		return fetchApi(`/admin/links${qs ? `?${qs}` : ""}`, paginatedSchema(shareLinkSchema));
	},
	/** Revokes the link; idempotent on the server. */
	revoke: (id: string) => fetchVoid(`/admin/links/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
